"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateWindowStartDateComponent = exports.dateIsNotInRange = void 0;
var metrics_engine_1 = require("@tableau/metrics-engine");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var dateIsNotInRange = function (firstTimestamp, lastTimestamp, date) {
    if (!firstTimestamp || !lastTimestamp) {
        return true;
    }
    return date < firstTimestamp || date > lastTimestamp;
};
exports.dateIsNotInRange = dateIsNotInRange;
var getTimestampAtIndex = function (table, timestampAccessor, index) {
    if (table && table.length > 0 && index >= 0 && index < table.length) {
        return timestampAccessor(table[index]);
    }
    return undefined;
};
var initialStartDate = function (selectedDateWindow) {
    if ((selectedDateWindow === null || selectedDateWindow === void 0 ? void 0 : selectedDateWindow.type) === metrics_engine_1.DateWindowTypes.DEFINED_START) {
        return selectedDateWindow.startDate;
    }
    return undefined;
};
var DateWindowStartDateComponent = function (props) {
    var _a, _b;
    var _c = React.useState(false), showError = _c[0], setShowError = _c[1];
    var _d = React.useState(React.createElement("br", null)), errorText = _d[0], setErrorText = _d[1];
    var def = (0, metrics_engine_1.simpleDefinition)((0, metrics_engine_1.dateGranularityFromTrunc)(props.dateTrunc)).build();
    var timestampAccessor = (0, metrics_engine_1.buildTimestampAccessor)(def);
    var dataTable = props.data;
    var firstTimestamp = getTimestampAtIndex(dataTable, timestampAccessor, 0);
    var _e = React.useState((_a = initialStartDate(props.selectedDateWindow)) !== null && _a !== void 0 ? _a : firstTimestamp), startDate = _e[0], setStartDate = _e[1];
    React.useEffect(function () {
        props.onDateWindowChange(startDate ? (0, metrics_engine_1.createDefinedStartDateWindow)(startDate) : null);
    }, [startDate]);
    var lastTimestamp = (_b = getTimestampAtIndex(dataTable, timestampAccessor, (dataTable === null || dataTable === void 0 ? void 0 : dataTable.length) - 1)) !== null && _b !== void 0 ? _b : null;
    var handleChange = function (value) {
        // date is parsed incorrectly or not in range
        setShowError(value === null || (0, exports.dateIsNotInRange)(firstTimestamp, lastTimestamp, value));
        setErrorText(getErrorText(value));
    };
    var handleConfirm = function (value) {
        if (!showError) {
            setStartDate(value);
        }
    };
    var getErrorText = function (date) {
        if (date === null && firstTimestamp) {
            return Localize_1.Messages.CustomStartDateError({
                dateExample: (0, metrics_engine_1.dateFormatterFactory)(props.dateTrunc).slashFormat(firstTimestamp),
            });
        }
        else if (firstTimestamp &&
            lastTimestamp &&
            date !== null &&
            (0, exports.dateIsNotInRange)(firstTimestamp, lastTimestamp, date)) {
            return Localize_1.Messages.CustomStartDateRangeError({
                dateRangeString: (0, metrics_engine_1.dateFormatterFactory)(props.dateTrunc).dateRangeSlashFormat(firstTimestamp, lastTimestamp),
            });
        }
        return React.createElement("br", null);
    };
    return (React.createElement(widgets_1.DateInputField, __assign({}, {
        dateInputFieldType: widgets_1.DateInputFieldType.Outline,
        isDatePickerDateDisabled: function (date) { return (0, exports.dateIsNotInRange)(firstTimestamp, lastTimestamp, date); },
        hasDatePicker: true,
        testId: props.testId,
        onConfirm: handleConfirm,
        onChange: handleChange,
        selectedDate: startDate,
        message: errorText,
        valid: showError ? false : undefined,
        label: '',
        disabled: props.disabled,
    })));
};
exports.DateWindowStartDateComponent = DateWindowStartDateComponent;
//# sourceMappingURL=DateWindowStartDateComponent.js.map